import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { APPLICABLE_FEE_TYPES, propTypes } from '../../util/types';
import classNames from 'classnames';
import css from './OrderBreakdown.module.css';
import PropTypes from 'prop-types';

const ApplicableFee = props => {
  const { item, intl, lineItemClass } = props;


  // console.log('item-->', item);
  if (!item) return null;

  const [, id, feeType] = item.code.split('/');

  // Don't show listing title for global fees
  const listingTitle = id === 'global' ? null : item.listingTitle;
  const feeLabel = intl.formatMessage({ id: `OrderBreakdown.applicableFee` }, { feeType });
  return (
    <div className={classNames(css.lineItem, lineItemClass)}>
      <span className={css.itemLabel}>
        {listingTitle ? `${listingTitle} ${feeLabel}`
          : feeLabel}</span>
      <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

ApplicableFee.propTypes = {
  item: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

export default ApplicableFee;
